<template>
  <div class="tag-operation-block">
    <div class="tag-operation-block__header">
      <strong>{{ definition.name }}</strong>
      <span class="text-muted small ml-1">(tag)</span>
    </div>

    <div class="tag-operation-block__content">
      <!-- Aggiungi -->
      <div class="tag-operation-block__section">
        <div class="tag-operation-block__section-label text-success">
          <CIcon name="cil-plus" size="sm" class="mr-1"/>
          <span v-translate translate-context="tag_manager.action">Aggiungi</span>
        </div>
        <div class="tag-operation-block__section-controls">
          <PTagInput
            :value="addValues"
            @input="addValues = $event"
            :allowed_tags="suggestedTags"
            :addable="true"
            :placeholder="$pgettext('tag_manager.add_tags', 'Digita e premi Invio...')"
            class="tag-operation-block__input"
          />
          <CButton
            size="sm"
            color="success"
            :disabled="addValues.length === 0 || applying"
            @click="onApplyAdd"
          >
            <CSpinner v-if="applying === 'add'" size="sm"/>
            <span v-else v-translate translate-context="tag_manager.action">Aggiungi</span>
          </CButton>
        </div>
      </div>

      <!-- Rimuovi -->
      <div class="tag-operation-block__section">
        <div class="tag-operation-block__section-label text-danger">
          <CIcon name="cil-minus" size="sm" class="mr-1"/>
          <span v-translate translate-context="tag_manager.action">Rimuovi</span>
        </div>
        <div class="tag-operation-block__section-controls">
          <PTagInput
            :value="removeValues"
            @input="removeValues = $event"
            :allowed_tags="suggestedTags"
            :addable="true"
            :placeholder="$pgettext('tag_manager.remove_tags', 'Tag da rimuovere...')"
            class="tag-operation-block__input"
          />
          <CButton
            size="sm"
            color="danger"
            :disabled="removeValues.length === 0 || applying"
            @click="onApplyRemove"
          >
            <CSpinner v-if="applying === 'remove'" size="sm"/>
            <span v-else v-translate translate-context="tag_manager.action">Rimuovi</span>
          </CButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PTagInput from '@/domain/core/components/PTagInput'

export default {
  name: 'TagOperationBlock',
  components: {
    PTagInput
  },
  props: {
    definition: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      applying: false,
      addValues: [],
      removeValues: []
    }
  },
  computed: {
    suggestedTags() {
      if (this.definition.suggestions) {
        return [...this.definition.suggestions]
          .sort((a, b) => b.count - a.count)
          .map(s => s.value)
      }
      return []
    }
  },
  methods: {
    async onApplyAdd() {
      if (this.addValues.length === 0) return
      this.applying = 'add'
      try {
        await this.emitPromised('apply', {
          code: this.definition.code,
          operation: {action: 'add', values: [...this.addValues]}
        })
        this.addValues = []
      } finally {
        this.applying = false
      }
    },

    async onApplyRemove() {
      if (this.removeValues.length === 0) return
      this.applying = 'remove'
      try {
        await this.emitPromised('apply', {
          code: this.definition.code,
          operation: {action: 'remove', values: [...this.removeValues]}
        })
        this.removeValues = []
      } finally {
        this.applying = false
      }
    },

    reset() {
      this.addValues = []
      this.removeValues = []
      this.applying = false
    }
  }
}
</script>

<style scoped>
.tag-operation-block {
  background: #f8f9fa;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  padding: 12px;
  margin-top: 12px;
}

.tag-operation-block__header {
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid #e0e0e0;
}

.tag-operation-block__content {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.tag-operation-block__section {
  display: flex;
  align-items: center;
  gap: 12px;
}

.tag-operation-block__section-label {
  display: flex;
  align-items: center;
  min-width: 80px;
  font-size: 0.85rem;
  font-weight: 500;
}

.tag-operation-block__section-controls {
  display: flex;
  align-items: center;
  flex-grow: 1;
  gap: 8px;
}

.tag-operation-block__input {
  flex-grow: 1;
  max-width: 350px;
}
</style>
